import React from "react";

import { Control } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "~/components/ui/form";
import { Input } from "~/components/ui/input";
import { AddressFormValues } from "~/pages/clients/components/client-detail/address/form/AddressForm";

interface AddressFieldsProps {
  control: Control<AddressFormValues>;
}

const AddressFields: React.FC<AddressFieldsProps> = ({ control }) => {
  return (
    <>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FormField
          control={control}
          name="street"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Calle <span className="text-red-500">*</span>
              </FormLabel>
              <FormControl>
                <Input placeholder="Ej: Av. Providencia" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="number"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Número <span className="text-red-500">*</span>
              </FormLabel>
              <FormControl>
                <Input placeholder="Ej: 123" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      <FormField
        control={control}
        name="complement"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Complemento</FormLabel>
            <FormControl>
              <Input
                placeholder="Ej: Oficina 501"
                {...field}
                value={field.value || ""}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FormField
          control={control}
          name="city"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Ciudad <span className="text-red-500">*</span>
              </FormLabel>
              <FormControl>
                <Input placeholder="Ej: Santiago" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </>
  );
};

export default AddressFields;
